import { createNode } from '@glueapp/graph-types';

export const Subtract = createNode({
    id: 'Subtract',
    name: 'Subtract',
    description: 'A Node for subtracting numbers',
    aiDescription:
        'Subtracts Number2 from Number1. Connect values to "Number1" and "Number2" input ports; the "Result" output port provides the difference.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number1: { kind: 'number' },
        Number2: { kind: 'number' },
    },
    outPorts: {
        Result: { kind: 'number' },
    },
    execute: function (input) {
        return { output: { Result: input.inPorts.Number1 - input.inPorts.Number2 } };
    },
});
